import { FCX } from "@datassential/platform-ui-lib";
import { useRestaurants } from "@core/CommonDataContext";
import {
    ConsumerGroupsTableItem,
    useConsumerGroupsTableMetrics
} from "./ConsumerGroupsTableConfig";
import { useMemo } from "react";
import Common from "@pages/Profile/components/ConsumerGroups/Common";
import { useConsumerGroupsContext } from "@pages/Profile/components/ConsumerGroups/ConsumerGroups";

const Restaurants: FCX = (props) => {
    const getMetricsData = useConsumerGroupsTableMetrics();
    const { data } = useConsumerGroupsContext();

    const options = useRestaurants();

    const itemsData = useMemo(
        (): ConsumerGroupsTableItem[] => {
            return (data.restaurants ?? []).map((item) => {
                const itemData = options.find((i) => i.id === item.id);

                return {
                    id: item.id,
                    name: itemData?.name ?? '',
                    baseSize: item.base ?? 0,
                    metrics: getMetricsData(item.metrics ?? []),
                };
            });
        },
        [options, data.restaurants, getMetricsData]
    );

    return (
        <Common {...props} data={itemsData} isVirtualized/>
    );
}

export default Restaurants;